<template>
  <div>
    <div class="vx-card p-6">
      <div class="vx-row">
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
            <label class="vs-input--label">{{ $t('badges.title') }}</label>
            <vs-input class="w-full" v-model="titleSearch" type="text" data-vv-validate-on="blur" />
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
            <label class="vs-input--label">{{ $t('badges.moduleType') }}</label>
            <v-select class="w-full" v-model="moduleTypeSearch" :clearable="false"
                      :options="moduleTypeOptionsSearch" :reduce="(option) => option.value">
                <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
            </v-select>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
            <label class="vs-input--label">{{ $t('badges.badgesType') }}</label>
            <v-select class="w-full" v-model="badgesTypeSearch" :clearable="false"
                      :options="badgesTypeOptionsSearch" :reduce="(option) => option.value">
                <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
            </v-select>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <vs-button icon="icon-search" icon-pack="feather" color="primary" @click="search" class="mt-6">
                {{ $t('button.search') }}
            </vs-button>
        </div>
        <div class="vx-col w-full mt-5">
          <vs-button @click="openPopup" color="primary" type="border" icon-pack="feather" icon="icon-plus">
            {{ $t('button.addNew') }}
          </vs-button>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <ag-grid-vue style="height: 55vh" ref="agGridTable"
              class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
              :defaultColDef="defaultColDef" :rowData="badgesData" :animateRows="true"
              :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }" @grid-ready="onGridReady"
              :autoSizeStrategy="autoSizeStrategy">
          </ag-grid-vue>
          <div class="vx-row mt-8" v-if="totalElements > 0">
              <div style="min-width:200px" class="vx-col md:w-1/2 w-full ">
                  <span class="content-page font-bold ml-6">{{ $t('dashboard.display') }}: </span>
                  <span class="text-page">
                      {{ countElementPage > totalElements ? totalElements : countElementPage }} / {{
                      totalElements }}
                  </span>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                  <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage" />
              </div>
          </div>
        </div>
      </div>
    </div>
    <vs-popup :title="$t('button.addNew')" :active.sync="popupActiveUse" class="custom-popup">
      <div class="vx-row items-center">
        <div class="vx-col sm:w-1/2 w-full upload-area">
          <div class="file-uploads">
            <div class="mx-auto w-64 h-64 overflow-hidden relative rounded-full cursor-pointer group-image-badges-edit" @click="triggerFileInput">
              <input ref="fileInput" type="file" id="imageUpload" class="hidden" @change="handleFileChange">
              <div class="absolute inset-x-0 inset-y-0 object-cover w-full h-full" :style="{ backgroundImage: `url(${imageUrl})`, backgroundColor: '#059862'}"></div>
              <div class="icon-edit-badges flex items-center justify-center w-[50px] h-[50px] rounded-full bg-[#059862] bottom-[10px] absolute left-1/2 transform -translate-x-1/2 text-white z-2">
                  <feather-icon icon="UploadCloudIcon"></feather-icon>
              </div>
            </div> 
          </div>
          <!-- <div class="table-files mt-5">
            <vs-table stripe :pagination="files.length > 0" maxItems="4" :data="files"
                noDataText="Không có dữ liệu">
                <template slot="thead">
                    <vs-th>{{ $t('multipleChoice.name') }}</vs-th>
                </template>
                <template >
                    <vs-tr >
                        <vs-td class="text-primary">
                            {{ files.name }}
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
          </div> -->
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div class="mb-2">
            <label class="vs-input--label required">{{ $t('badges.title') }}</label>
            <vs-input class="w-full" v-model="badges.title" type="text" data-vv-validate-on="blur" v-validate="'required'" name="title" />
            <span class="text-danger text-sm">{{ errors.first('title') }}</span>
          </div>
          <div class="mb-2">
            <label class="vs-input--label required">{{ $t('badges.content') }}</label>
            <vs-textarea v-model="badges.content" data-vv-validate-on="blur" v-validate="'required'" name="content" :style="{marginBottom:'0px'}"/>
            <span class="text-danger text-sm">{{ errors.first('content') }}</span>
          </div>
          <div class="mb-2">
          <label class="vs-input--label required">{{ $t('badges.point') }}</label>
            <vs-input class="w-full" v-model="badges.point" type="number" data-vv-validate-on="blur" v-validate="'required'" name="point" />
            <span class="text-danger text-sm">{{ errors.first('point') }}</span>
          </div>
          <div class="mb-2">
            <label class="vs-input--label required">{{ $t('badges.timeCount') }}</label>
            <vs-input class="w-full" v-model="badges.timeCount" type="number" data-vv-validate-on="blur" v-validate="'required'" name="timeCount" />
            <span class="text-danger text-sm">{{ errors.first('timeCount') }}</span>
          </div>
          <div class="mb-2">
            <label class="vs-input--label">{{ $t('badges.moduleType') }}</label>
            <v-select class="w-full" v-model="badges.moduleType" :clearable="false" :options="moduleTypeOptions" :reduce="(option) => option.value">
              <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
            </v-select>
          </div> 
          <div>
            <label class="vs-input--label">{{ $t('badges.badgesType') }}</label>
            <v-select class="w-full" v-model="badges.badgesType" :clearable="false" :options="badgesTypeOptions" :reduce="(option) => option.value">
              <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
            </v-select>
          </div>
        </div>
        <div class="vx-col w-full mt-5 text-right">
          <vs-button @click="saveBadges">{{ $t('button.save') }}</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import Pagination from "../../ui-elements/Pagination.vue";
import { AgGridVue } from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
export default {
    components: {
        vSelect,
        Pagination,
        AgGridVue,
        CellRendererActions
    },
    data() {
        return {
            popupActiveUse: false,
            gridApi: null,
            badges: {
              title:null,
              content:null,
              timeCount:null,
              point:null,
              moduleType:1,
              badgesType:1,
              fileId:null,
            },
            titleSearch:null,
            moduleTypeSearch:null,
            moduleTypeOptionsSearch:[
              { value: null, label: this.$t('menuOrganization.all')},
              { value: 1, label: 'Trắc nghiệm'},
              { value: 2, label: 'Điểm danh'},
              { value: 3, label: 'Bài tập đánh giá' },
              { value: 4, label: 'Đọc sách' }
            ],
            moduleTypeOptions:[
              { value: 1, label: 'Trắc nghiệm'},
              { value: 2, label: 'Điểm danh'},
              { value: 3, label: 'Bài tập đánh giá' },
              { value: 4, label: 'Đọc sách' }
            ],
            badgesTypeSearch:null,
            badgesTypeOptionsSearch:[
              { value: null, label: this.$t('menuOrganization.all')},
              { value: 1, label: 'Loại thường'},
              { value: 2, label: 'Loại đc giáo viên tặng'},
            ],
            badgesTypeOptions:[
              { value: 1, label: 'Loại thường'},
              { value: 2, label: 'Loại đc giáo viên tặng'},
            ],
            badgesData:[],
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('badges.stt'),
                    field: 'stt',
                    width: 100
                },
                {
                    headerName: this.$t('badges.title'),
                    field: 'title',
                    width: 250,
                },
                {
                  headerName: this.$t('badges.content'),
                    field: 'content',
                    width: 250
                },
                {
                    headerName: this.$t('badges.moduleType'),
                    field: 'moduleType',
                    valueFormatter: function(params) {
                      const selectedOption = this.moduleTypeOptionsSearch.find(option => option.value === params.value);
                      return selectedOption ? selectedOption.label : "";
                    }.bind(this),
                    width: 250
                },
                {
                    headerName: this.$t('badges.badgesType'),
                    field: 'badgesType',
                    valueFormatter: function(params) {
                      const selectedOption = this.badgesTypeOptionsSearch.find(option => option.value === params.value);
                      return selectedOption ? selectedOption.label : "";
                    }.bind(this),
                    width: 250
                },
                {
                    headerName: this.$t('badges.actions'),
                    field: 'actions',
                    width: 150,
                    cellRenderer: 'CellRendererActions',
                    cellStyle: { textAlign: 'right' },
                    suppressSizeToFit: true,
                },
            ],
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            pageNumber: 0,
            pageSize: 20,
            totalPages: 0,
            countElementPage: 0,
            totalElements: 0,
            totalPages:0,
            currentPage: 1,
            filesId: [],
            selectedFile: null, 
            imageUrl: '',
        }
    },
    created() {
      this.search();
    },
    methods: {
      async search() {
        const body = {
            title: this.titleSearch,
            moduleType: this.moduleTypeSearch,
            badgesType: this.badgesTypeSearch,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
        };
        
        this.$vs.loading();
        try {
          const response = await this.$crm.post('/school-badges/find-by-condition', body); 
          
          this.badgesData = response.data.content.map((el, index) => {
            el.stt = index + 1; 
            return el;
          });
          
          this.countElementPage = this.currentPage * this.pageSize;
          this.totalElements = response.data.content.length;
          this.totalPages = Math.ceil(this.totalElements / this.pageSize);
        } catch (error) {
          this.$vs.notify({
            text: error.response.data.message || error.response.data.error_description || error.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        } finally {
          this.$vs.loading.close(); 
        }
      },
      openPopup() {
        this.popupActiveUse = true
        this.badges.title = null
        this.badges.content = null
        this.badges.timeCount = null
        this.badges.point = null
        this.badges.moduleType = 1
        this.badges.badgesType = 1
        this.selectedFile = null
        this.imageUrl = '';
      },
      triggerFileInput() {
        this.$refs.fileInput.click(); 
      },
      handleFileChange(event) {
        this.selectedFile = event.target.files[0];
        if (this.selectedFile) {
          this.imageUrl = URL.createObjectURL(this.selectedFile);
        }
      },
      async uploadImage() {
        let formData = new FormData();
        formData.append('files', this.selectedFile);
        
        let config = {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        };

        try {
            let url = `/school-badges/upload-file`;
            let response = await this.$crm.post(url, formData, config);
            this.filesId = response.data.fileManager.id;
            return true;  

        } catch (error) {
            this.$vs.notify({
                text: 'Image upload error: ' + error,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
            return false;  
        }
      },
      async saveBadges() {
          if (!this.badges.title || !this.badges.content || !this.badges.point || 
              !this.badges.timeCount || !this.badges.moduleType || !this.badges.badgesType) {
              this.$vs.notify({
                  text: this.$t('multipleChoice.notice_field'),
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'warning',
              });
              return;
          }

          if (!this.selectedFile) {
              this.$vs.notify({
                  text: 'Chưa nhập ảnh',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'warning',
              });
              return;
          }

          this.$vs.loading(); 

          const uploadSuccess = await this.uploadImage();
          if (!uploadSuccess) {
              this.$vs.loading.close();  
              return;
          }

          this.badges.fileId = this.filesId;

          try {
              await this.$crm.post('/school-badges/create', this.badges);
              
              this.popupActiveUse = false;
              this.search();

              this.$vs.notify({
                  text: this.$t('multipleChoice.create_success'),
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'success',
              });
          } catch (err) {
              this.$vs.notify({
                  text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
              });
          } finally {
              this.$vs.loading.close(); 
          }
      },
      onGridReady(params) {
        this.gridApi = params.api;
      },
      loadPage: function (currentPage) {
        if (parseInt(currentPage) - 1 != this.pageNumber) {
          this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
          this.search();
        }
      },
    },
    watch: {
      '$store.state.isDeleteCategory'(val) {
        if (val) {
          this.search();
          this.$store.commit('DELETE_CATEGORY', false);
        }
      },
    }
}
</script>
<style scoped>
.required::after {
  content: '* ';
  color: red;
}
.custom-popup >>> .vs-popup{
  width: 60vw; 
  max-width: 1200px; 
}
.upload-area .file-upload {
  width: 150px;
  height: 150px;
  border: dashed 2px rgba(var(--vs-primary), 1);
  border-radius: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.upload-area .button-upload button {
  border-radius: 1.5rem;
}
.upload-area .file-label {
  color: #C0C0C0;
}
.table-files .vs-table--tbody,
.table-files .vs-table--thead {
  position: static;
}
.table-files  .vs-pagination--buttons {
  z-index: 0;
}
.icon-edit-badges {
    width: 40px;
    height: 40px;
    background-color: #059862;
    bottom: 10px;
    left: 50%;
    opacity:1;
    visibility: visible;
    transition: all .1s ease-in-out;
}
.group-image-badges-edit:hover img{
    filter: grayscale(0.2);
}
</style>